import { render, staticRenderFns } from "./ChartOccupancyRate.vue?vue&type=template&id=65a71886&"
import script from "./ChartOccupancyRate.vue?vue&type=script&lang=js&"
export * from "./ChartOccupancyRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports